export default __webpack_public_path__ + "static/media/btn-drift-off@3x.149ee190.png";